import React from 'react';

import { Query } from '@apollo/client/react/components';

import { GET_ORGANIZATION, IGetOrganization } from '../graphql/queries/GetOrganization';
import { WEB_API_URL } from '../helpers/globals';

type IProps = {
  children?: React.ReactNode;
  className?: string;
};

const PartnerSpecificHomeLink = (props: IProps) => (
  <Query<IGetOrganization> query={GET_ORGANIZATION}>
    {({ loading, error, data }) => {
      const homeLinkUrl =
        loading || error || !data || !data.organization || !data.organization.slug
          ? WEB_API_URL
          : `${WEB_API_URL}/${data.organization.slug}`;

      return (
        <a className={props.className} href={homeLinkUrl} target="_blank" rel="noopener noreferrer">
          {props.children}
        </a>
      );
    }}
  </Query>
);

export default PartnerSpecificHomeLink;
